import { Chip, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { AddAlert, Cancel, TableChart, ThumbDownAlt, ThumbUp, Update } from "@material-ui/icons";
import { useAuth } from "@airborne/react-admin";
import React, { useEffect, useState } from "react";
import {
  Button,
  RadioButtonGroupInput,
  SelectInput,
  TextInput,
  Toolbar,
  maxValue,
  minValue,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { ExperienceNoteType } from "../../../../../src/Enums/ExperienceNoteType";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { ServiceableTransactionTypeKey } from "../../../../Constants/Constant";
import { GetCarrierType } from "../../../../Enums/CarrierType";
import { ServiceableStatu } from "../../../../Enums/ServiceableStatus";
import { ShippingType } from "../../../../Enums/ShippingType";
import { useAppDataProvider } from "../../../../dataprovider";
import { ShippingTypeChoices } from "../../Constant/Source";
import { RequestServiceablePutModel } from "../../Models/RequestServiceableModel";
import ExperienceSoftWarningDialog from "../ExperiencePopup";
import ServiceableStatusChip from "../Statu/ServiceableStatusChip";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
});

const ServiceableUpdate = props => {
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const [isButtonShow, setIsAButtonShow] = useState(props.serviceable?.status !== ServiceableStatu.Offered);
  const classes = useStyles();
  const [serviceableFormDisabled, setServiceableFromDisabled] = useState(true);
  const [approveButtonShown, setApproveButtonShown] = useState(false);
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const requestId = props.requestId;

  useEffect(() => {
    setIsAButtonShow(props.serviceable?.status !== ServiceableStatu.Offered);
  }, [props.serviceable]);

  const AcceptOrRejectButtonClick = (serviceable, isApproved) => e => {
    AcceptOrRejectServiceable(serviceable, isApproved);
  };

  function isReceiving() {
    return props?.requestDetail?.transactionType === ServiceableTransactionTypeKey;
  }

  const AcceptOrRejectServiceable = async (serviceable, isApproved) => {
    let requestServiceableUpdateModel: RequestServiceablePutModel;

    requestServiceableUpdateModel = { ...serviceable };

    requestServiceableUpdateModel.RequestedDeliveryDate = new Date();
    requestServiceableUpdateModel.Status = isApproved === true ? ServiceableStatu.Accepted : ServiceableStatu.Rejected;

    requestServiceableUpdateModel.updatedBy = user?.employeeId;
    requestServiceableUpdateModel.updatedDate = new Date();

    dataProvider
      .putRequestServiceable(requestServiceableUpdateModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        setIsAButtonShow(true);
        history.push("/requestorders/" + requestId + "/1");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const UpdateServiceableButtonClick = e => {
    UpdateServiceable(e);
  };

  const UpdateServiceable = e => {
    let requestServiceableUpdateModel: RequestServiceablePutModel = new RequestServiceablePutModel();

    requestServiceableUpdateModel.id = props.serviceable.id;
    requestServiceableUpdateModel.RequestId = props.serviceable.requestId;
    requestServiceableUpdateModel.Status = props.serviceable.status;
    requestServiceableUpdateModel.SubmittedBy = props.serviceable.submittedBy;
    requestServiceableUpdateModel.SubmittedDate = props.serviceable.submittedDate;
    requestServiceableUpdateModel.Awb = e.serviceableAwb;
    requestServiceableUpdateModel.CarrierEnum = e.serviceableCarrierEnum;
    requestServiceableUpdateModel.EstimatedDeliveryDate = e.serviceableEstimatedDeliveryDate;
    requestServiceableUpdateModel.FlightDate = e.serviceableFlightDate;
    requestServiceableUpdateModel.FlightNo = e.serviceableFlightNo;
    requestServiceableUpdateModel.Pn = e.serviceablePn;
    requestServiceableUpdateModel.Sn = e.serviceableSn;
    requestServiceableUpdateModel.RequestedDeliveryDate = new Date();
    requestServiceableUpdateModel.ShippingTypeEnum = e.shippingTypeEnum;
    requestServiceableUpdateModel.updatedBy = user?.employeeId;
    requestServiceableUpdateModel.updatedDate = new Date();

    PutUpdate(requestServiceableUpdateModel);
  };

  const PutUpdate = async (putModel: RequestServiceablePutModel) => {
    setLoading(true);
    dataProvider
      .putRequestServiceable(putModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        history.push("/requestorders/" + requestId + "/1");
        setIsAButtonShow(true);
        setApproveButtonShown(false);
        setServiceableFromDisabled(true);
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const openEditableFields = e => {
    setApproveButtonShown(true);
    setServiceableFromDisabled(false);
  };

  const cancelUpdate = e => {
    setApproveButtonShown(false);
    setServiceableFromDisabled(true);
  };
  const resetValidate = form => e => {
    setTimeout(() => form?.restart?.(form?.getState?.()?.values), 500);
  };
  return (
    <>
      <Form
        onSubmit={UpdateServiceableButtonClick}
        render={({ handleSubmit, form, values }) => (
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <Separator />
                <Grid {...gridContainerProps}>
                  {isReceiving() && (
                    <Chip
                      key={999999}
                      color="primary"
                      variant="outlined"
                      label={props?.requestDetail?.transactionType}
                      icon={<TableChart />}
                    />
                  )}
                  <SectionTitle label="Serviceable Info" />
                  <ServiceableStatusChip serviceable={props.serviceable} />
                </Grid>
                <Separator />
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}>
                    <RadioButtonGroupInput
                      source="shippingTypeEnum"
                      label="Shipping Type"
                      defaultValue={
                        props?.serviceable?.shippingTypeEnum === Number(ShippingType.None) ||
                        props?.serviceable?.shippingTypeEnum === null
                          ? ShippingType.RBH
                          : props?.serviceable?.shippingTypeEnum
                      }
                      fullWidth
                      choices={ShippingTypeChoices}
                      disabled={serviceableFormDisabled}
                      variant="outlined"
                    />
                    <TextInput
                      source="serviceablePn"
                      label="PN"
                      fullWidth
                      resettable
                      variant="outlined"
                      defaultValue={props.serviceable?.pn}
                      disabled={serviceableFormDisabled}
                      validate={required()}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextInput
                      source="serviceableAwb"
                      label="AWB No"
                      fullWidth
                      resettable
                      variant="outlined"
                      defaultValue={props.serviceable?.awb}
                      disabled={serviceableFormDisabled}
                      validate={required()}
                    />
                  </Grid>
                </Grid>
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}>
                    <TextInput
                      source="serviceableFlightNo"
                      label="Flight No"
                      fullWidth
                      resettable
                      variant="outlined"
                      defaultValue={props.serviceable?.flightNo}
                      disabled={serviceableFormDisabled}
                      validate={required()}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextInput
                      source="serviceableSn"
                      label="SN"
                      fullWidth
                      resettable
                      variant="outlined"
                      defaultValue={props.serviceable?.sn}
                      disabled={serviceableFormDisabled}
                      validate={required()}
                    />
                  </Grid>
                </Grid>
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}></Grid>
                  <Grid item xs={12} sm={5} />
                </Grid>
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}>
                    <SelectInput
                      source="serviceableCarrierEnum"
                      label="Carrier"
                      choices={GetCarrierType}
                      optionText="Description"
                      optionValue="Value"
                      fullWidth
                      variant="outlined"
                      defaultValue={props.serviceable?.carrierEnum}
                      disabled={serviceableFormDisabled}
                      validate={required()}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <CustomDatetime
                      fullWidth
                      source="serviceableFlightDate"
                      label="Flight Date"
                      inputVariant={"dialog"}
                      variant="outlined"
                      showTime
                      maxDate={values.serviceableEstimatedDeliveryDate}
                      validate={[required(), maxValue(values.serviceableEstimatedDeliveryDate)]}
                      defaultValue={props.serviceable?.flightDate}
                      disabled={serviceableFormDisabled}
                      onChange={resetValidate(form)}
                      onBlur={resetValidate(form)}
                    />
                  </Grid>
                </Grid>
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}></Grid>
                  <Grid item xs={12} sm={5}>
                    <CustomDatetime
                      fullWidth
                      source="serviceableEstimatedDeliveryDate"
                      label="Estimated Delivery Date"
                      inputVariant={"dialog"}
                      variant="outlined"
                      showTime
                      defaultValue={props.serviceable?.estimatedDeliveryDate}
                      disabled={serviceableFormDisabled}
                      minDate={values.serviceableFlightDate}
                      validate={minValue(values.serviceableFlightDate)}
                      onChange={resetValidate(form)}
                      onBlur={resetValidate(form)}
                    />
                  </Grid>
                </Grid>
                <Separator />
                {isReceiving() && (
                  <Chip
                    key={999999}
                    color="primary"
                    variant="outlined"
                    label="Core RN dönüşüdür, çıkış RN yapılmalıdır!"
                    icon={<AddAlert />}
                  />
                )}
                <Toolbar {...props} placeholder="" classes={classes}>
                  {approveButtonShown === false && (
                    <>
                      {user?.isCustomer === false && (
                        <Button
                          label="Edit Serviceable"
                          disabled={loading}
                          size="medium"
                          variant="contained"
                          style={isButtonShow ? { margin: "8px" } : { margin: "8px", background: "#ffc107" }}
                          onClick={openEditableFields}
                        >
                          {<Update />}
                        </Button>
                      )}

                      {user?.isCustomer && (
                        <>
                          <Button
                            label={loading ? "Serviceable is Accepted!" : "Accept Serviceable"}
                            disabled={isButtonShow}
                            size="medium"
                            variant="contained"
                            onClick={AcceptOrRejectButtonClick(props.serviceable, true)}
                            style={isButtonShow ? { margin: "8px" } : { margin: "8px", background: "seagreen" }}
                          >
                            {loading ? <CircularProgress size="2rem" color="secondary" /> : <ThumbUp />}
                          </Button>
                          <Button
                            label={loading ? "Serviceable is Rejected!" : "Reject Serviceable"}
                            disabled={isButtonShow}
                            size="medium"
                            variant="contained"
                            color="primary"
                            onClick={AcceptOrRejectButtonClick(props.serviceable, false)}
                            style={{ margin: "8px" }}
                          >
                            {loading ? <CircularProgress size="2rem" color="secondary" /> : <ThumbDownAlt />}
                          </Button>
                        </>
                      )}
                    </>
                  )}
                  {approveButtonShown === true && user?.isCustomer === false && (
                    <>
                      <Button
                        label={loading ? "Serviceable Info is updating!" : "Update Serviceable Arrival Info "}
                        disabled={loading}
                        size="medium"
                        variant="contained"
                        onClick={handleSubmit}
                        style={{ margin: "8px", background: "seagreen" }}
                      >
                        {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                      </Button>
                      <Button
                        label={loading ? "Cancel!" : "Cancel "}
                        disabled={loading}
                        size="medium"
                        variant="contained"
                        color="primary"
                        onClick={cancelUpdate}
                        style={{ margin: "8px" }}
                      >
                        {<Cancel />}
                      </Button>
                    </>
                  )}
                </Toolbar>
              </Grid>
            </Grid>
          </form>
        )}
      />
      <ExperienceSoftWarningDialog data={props?.experienceData} type={ExperienceNoteType.Serviceable} />
    </>
  );
};

const RbhRequestServiceableUpdate = props => {
  return (
    <ServiceableUpdate
      experienceData={props.experienceData}
      serviceable={props.serviceable}
      requestId={props.requestId}
      finalCallBack={e => props.finalCallBack()}
    />
  );
};

export default RbhRequestServiceableUpdate;
